<template>
    <div>
        <!-- 活动管理页面 -->
        <!-- 筛选条件 -->
        <div :class="preCls + 'filter'" style="margin-bottom: 20px">
            <Select
                style="width: 180px; margin-right: 15px"
                placeholder="上线状态"
                clearable
                v-model="filter.enabled"
                @on-change="search"
            >
                <Option
                    v-for="item in enums.isOnline"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>

            <Select
                style="width: 180px; margin-right: 15px"
                placeholder="商品分类"
                clearable
                v-model="filter.catalogId"
                @on-change="search"
            >
                <Option
                    v-for="item in catalogList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.title }}</Option
                >
            </Select>

            <Select
                style="width: 180px; margin-right: 15px"
                placeholder="推荐状态"
                clearable
                v-model="filter.recommend"
                @on-change="search"
            >
                <Option
                    v-for="item in enums.yesOrNo"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
        </div>

        <table-tool-bar style="margin-top: 16px">
            <template slot="left">
                <table-searcher
                    v-model="filter.sellName"
                    placeholder="请输入秒杀名称"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
            <Button
                :class="preCls + 'button-margin'"
                v-if="$can('add')"
                :disabled="loading"
                type="primary"
                @click="onClickAdd"
                >新增秒杀</Button
            >
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template v-slot:enabled="{ row }">
                <i-switch
                    v-model="row.enabled"
                    :disabled="!$can('update')"
                    size="large"
                    :true-value="1"
                    :false-value="0"
                    @on-change="toEnabled(row)"
                >
                    <span slot="open">上线</span>
                    <span slot="close">下线</span>
                </i-switch>
            </template>
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickInfo(row)"
                    >详情</Button
                >
                <PoptipButton
                    text="删除"
                    transfer
                    type="default"
                    title="您确定删除这条记录吗？"
                    v-if="row.enable === 0"
                    :ok="
                        () => {
                            rowConfirmDelete(row);
                        }
                    "
                ></PoptipButton>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showGActMsForm"
            :title="curId ? '秒杀详情' : '新增秒杀'"
            :width="800"
            :height="520"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <m-act-ms-form v-if="modal.showGActMsForm" :id="curId" />
        </smart-modal>
    </div>
</template>
<script>
import { mapCell, pipeCell } from "_c/grid/renderCell";
import MActMsForm from "./m-act-ms-form";
import { merchSellList, merchSellDel, merchSellEnable } from "@/api/merch-sell";
import yzyList from "_v/common/yzy-list";
import Enum from "@/config/global-enum";
import { catalogList } from "@/api/merch";

const PAGE_SIZE = 20;

export default {
    mixins: [yzyList],
    name: "m-act-ms-list",

    components: {
        MActMsForm,
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: this.$cache.mActMs || {
                pageNo: 1,
                pageSize: PAGE_SIZE,
                sellName: "",
                sellMode: 2,
                enabled: "",
                catalogId: "",
                recommend: "",
            },
            enums: {
                isOnline: this.$enum.get("isOnline").toList(),
                yesOrNo: this.$enum.get("yesOrNo").toList(),
            },
            curId: "",
            page: {
                total: 0,
                list: [],
            },
            modal: {
                showGActMsForm: false,
            },
            catalogList: [],
        };
    },

    computed: {
        columns() {
            return [
                {
                    type: "index",
                    title: "序号",
                    align: "center",
                    width: 60,
                },
                {
                    key: "sellName",
                    title: "秒杀名称",
                    align: "left",
                    minWidth: 160,
                    tooltip: true,
                },
                {
                    key: "merchName",
                    title: "秒杀商品",
                    align: "left",
                    minWidth: 160,
                    tooltip: true,
                },
                {
                    key: "catalogName",
                    title: "商品分类",
                    align: "left",
                    minWidth: 100,
                    tooltip: true,
                },
                {
                    key: "startTime",
                    title: "开始时间",
                    align: "center",
                    minWidth: 120,
                },
                {
                    key: "endTime",
                    title: "结束时间",
                    align: "center",
                    minWidth: 120,
                },
                {
                    key: "originalPrice",
                    title: "原价(元)",
                    align: "right",
                    minWidth: 120,
                    render: pipeCell("currency"),
                },
                {
                    key: "actAmount",
                    title: "活动价(元)",
                    align: "right",
                    minWidth: 120,
                    render: pipeCell("currency"),
                },
                {
                    key: "limitNum",
                    title: "限购数",
                    align: "center",
                    minWidth: 80,
                },
                {
                    key: "enabled",
                    title: "状态",
                    align: "center",
                    width: 100,
                    slot: "enabled",
                    fixed: "right",
                },
                {
                    key: "action",
                    title: "操作",
                    align: "center",
                    width: 100,
                    slot: "action",
                    fixed: "right",
                },
            ];
        },
    },

    watch: {},

    created() {
        this.fetch();
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80;
        });
    },

    methods: {
        fetch() {
            this.loading = true;

            Promise.all([
                merchSellList(this.filter),
                catalogList({ pageNo: 1, pageSize: 999 }),
            ])
                .then((args) => {
                    var [page, catalogList] = args;
                    this.setPageData(page.data);

                    this.catalogList = catalogList.data.page.list || [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        search() {
            this.filter.pageNo = 1;
            this.fetch();
        },

        setPageData(data) {
            var dataList = data.page.list;
            dataList.forEach((v) => {
                v.actAmount = v.actAmount / 100;
                v.originalPrice = v.originalPrice / 100;
            });
            this.page.list = dataList;
            this.page.total = parseInt(data.page.totalCount);
        },

        onClickAdd(e) {
            this.modal.showGActMsForm = true;
            this.curId = "";
        },

        rowClickInfo(row) {
            this.curId = row.id;
            this.modal.showGActMsForm = true;
        },
        toEnabled(row) {
            this.loading = true;
            merchSellEnable(row.id)
                .then(() => {
                    this.$Message.success(this.$t("tips.update.success"));
                })
                .finally(() => this.fetch());
        },
        rowConfirmDelete(row) {
            this.loading = true;
            merchSellDel(row.id)
                .then((res) => {
                    this.$Message.success(this.$t("tips.delete.success"));
                })
                .then((res) => this.fetch())
                .finally(() => (this.loading = false));
        },
    },
};
</script>
<style lang="less" scoped></style>
